import React from "react";
import KLButton from "../KLButton";
import {
  EmptyStateContainer,
  AnimationWrapper,
  EmptyStateTitle,
  EmptyStateDescription,
  ButtonWrapper,
} from "./styles";

export type IllustrationType = "box" | "users" | "calendar" | "chart";

interface KLEmptyStateProps {
  illustration: React.ReactNode;
  title: string;
  description?: string;
  actionButtonTitle?: string;
  onActionClick?: () => void;
  size?: "small" | "medium" | "large";
}

const KLEmptyState: React.FC<KLEmptyStateProps> = ({
  illustration,
  title,
  description,
  actionButtonTitle,
  onActionClick,
  size = "medium",
}) => {
  return (
    <EmptyStateContainer role="status" aria-live="polite">
      <AnimationWrapper $size={size} aria-hidden="true">
        {illustration}
      </AnimationWrapper>
      <EmptyStateTitle id="empty-state-title">{title}</EmptyStateTitle>
      {description && (
        <EmptyStateDescription id="empty-state-description">
          {description}
        </EmptyStateDescription>
      )}
      {actionButtonTitle && onActionClick && (
        <ButtonWrapper role="region" aria-label="פעולות זמינות">
          <KLButton
            title={actionButtonTitle}
            onClick={onActionClick}
            secondary
          />
        </ButtonWrapper>
      )}
    </EmptyStateContainer>
  );
};

export default KLEmptyState;
